import * as types from '../actions/types'
import Immutable from 'immutable'
import diff from 'immutablediff'
import patch from 'immutablepatch'

import {
    isPrimitive,
    adicion,
    solicitudservicioitemcenco,
    enums
} from '../utils/helpers'

const INITIAL_STATE = Immutable.fromJS({
    id: null,
    documento: null,
    modalSummary: {
        show: false,
        data: {},
        unchanged: {},
        url: '',
        type: '',
        editar: false
    },
    modalCreateVerificacion: {
        show: false,
        data: null,
        unchanged: null,
        url: '',
        type: '',
    },
    modalCreateEntrega: {
        show: false,
        data: null,
        unchanged: null,
        criterios: {},
        url: '',
        type: '',
    },
    modalAddAdicional: {
        show: false,
        guardando: false,
        data: null,
        unchanged: null,
        detalles: [],
        url: '',
        type: '',
    },


})

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.MODIFICAR_INPUTS_DOCUMENTOS:
            if (isPrimitive(action.payload.value)) {
    			state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
            } else {
                if (action.payload.immutable === false) {
                    state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
                } else {
                    state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
                }
            }
            return state
        case types.MOSTRAR_MODAL_RESUMEN_DOCUMENTO:
            if (action.payload.show) {
                state = state.setIn(['modalSummary', 'show'], true)
                state = state.setIn(['modalSummary', 'url'], action.payload.url)
                state = state.setIn(['modalSummary', 'type'], action.payload.type)
            } else {
                state = state.set('modalSummary', INITIAL_STATE.get('modalSummary'))
            }
            return state
        case types.MOSTRAR_MODAL_CREAR_ENTREGA_DOCUMENTO:
            if (action.payload.show) {
                const entregas = state.getIn(['modalSummary', 'data', 'entregas']);
                const index = entregas.findIndex(e => e.get('id') == action.payload.id);
                state = state.setIn(['modalCreateEntrega', 'show'], true)
                state = state.setIn(['modalCreateEntrega', 'data'], state.getIn(['modalSummary', 'data', 'entregas', String(index)]))
                state = state.setIn(['modalCreateEntrega', 'criterios'], Immutable.fromJS(action.payload.criterios))
                state = state.setIn(['modalCreateEntrega', 'unchanged'], state.getIn(['modalSummary', 'data', 'entregas', String(index)]))
                state = state.setIn(['modalCreateEntrega', 'url'], state.getIn(['modalSummary', 'url']))
                state = state.setIn(['modalCreateEntrega', 'type'], state.getIn(['modalSummary', 'type']))
            } else {
                state = state.set('modalCreateEntrega', INITIAL_STATE.get('modalCreateEntrega'))
            }
            return state
        case types.MOSTRAR_MODAL_ADICIONAR_ADICIONAL:
            
            if (action.payload.show) {

                const documento_id = state.getIn(['documento', 'id']) ? state.getIn(['documento', 'id']) : null

                state = state.setIn(['modalAddAdicional', 'show'], true)
                state = state.setIn(['modalAddAdicional', 'url'], action.payload.url)
                state = state.setIn(['modalAddAdicional', 'type'], action.payload.type)
                state = state.setIn(['modalAddAdicional', 'data'], Immutable.fromJS(adicion(documento_id)))
                state = state.setIn(['modalAddAdicional', 'data', 'fecha_entrega'], state.getIn(['modalSummary', 'data', 'fecha_entrega']))
                state = state.setIn(['modalAddAdicional', 'detalles'], state.getIn(['modalSummary', 'data', 'detalles']))

            } else {
                state = state.set('modalAddAdicional', INITIAL_STATE.get('modalAddAdicional'))
            }
            return state

		case types.ADICIONAR_NUEVO_CENCO_ADICIONAL:
            let actual = state.getIn(['modalAddAdicional', 'data', 'cencos']).reduce((a ,b) => { a += Number(b.get('porcentaje')); return a }, 0)
			state = state.updateIn(['modalAddAdicional', 'data', 'cencos'], list => list.push(Immutable.fromJS(solicitudservicioitemcenco(actual))))
			return state
        case types.ELIMINAR_CENCOS_ADICIONAL:
			state = state.updateIn(['modalAddAdicional', 'data', 'cencos'], list => list.filter(x => !x.get('selected')))
			return state
        case types.ACTUALIZAR_MODAL_SUMMARY_DOCUMENTO:

            const ops = diff(state.getIn(['modalSummary', 'data']), Immutable.fromJS(action.payload))
            
            state = state.setIn(['modalSummary', 'data'], patch(state.getIn(['modalSummary', 'data']), ops))
            state = state.setIn(['modalSummary', 'unchanged'], patch(state.getIn(['modalSummary', 'data']), ops))

            const solicitud = state.getIn(['modalSummary', 'data', 'solicitude'])
            const solicitud_id = solicitud.get('id')
            const type = enums.solicitudes.tipos[solicitud.get('tipo')].type
            const url = `solicitudes/${enums.solicitudes.tipos[solicitud.get('tipo')].url}/${solicitud_id}`

            state = state.setIn(['modalSummary', 'type'], type)
            state = state.setIn(['modalSummary', 'url'], url)

            return state
        case types.ELIMINAR_ARCHIVOS_DOCUMENTO:
            state = state.updateIn(['modalSummary', 'data', 'adjuntos'], list => list.filter(x => !x.get('selected')))
            return state
        case types.MOSTRAR_MODAL_CREAR_VERIFICACION_SOMA_DOCUMENTO:
            if (action.payload.show) {
                state = state.setIn(['modalCreateVerificacion', 'show'], true)
                state = state.setIn(['modalCreateVerificacion', 'data'], state.getIn(['modalSummary', 'data', 'verificaciones_sst', String(action.payload.index)]))
                state = state.setIn(['modalCreateVerificacion', 'unchanged'], state.getIn(['modalSummary', 'data', 'verificaciones_sst', String(action.payload.index)]))
                state = state.setIn(['modalCreateVerificacion', 'url'], state.getIn(['modalSummary', 'url']))
                state = state.setIn(['modalCreateVerificacion', 'type'], state.getIn(['modalSummary', 'type']))
            } else {
                state = state.set('modalCreateVerificacion', INITIAL_STATE.get('modalCreateVerificacion'))
            }
            return state
        case types.DESHABILITAR_BOTON_MODAL_ADICIONAR_ADICION:
            state = state.setIn(['modalAddAdicional', 'guardando'], action.payload)
            return state
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/documentos.js